/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type WorkflowRuleTypeEnum = 'UNDEFINED' | 'SHOPPING_BASKET_RULES';

export const WorkflowRuleTypeEnum = {
    UNDEFINED: 'UNDEFINED' as WorkflowRuleTypeEnum,
    SHOPPING_BASKET_RULES: 'SHOPPING_BASKET_RULES' as WorkflowRuleTypeEnum
};

